import BibleSideBar from "./BibleSideBar";
import NavigationBar from "./NavigationBar";
import { useChromePart } from "./ChromeVisibility";

interface SideBarProps {
  chosenTranslation: any,
  queriedBooks: any,
  queriedVerses: any,
  chosenBook: any,
  chosenChapter: any,
  queryInput: string,
  setQueryInput: (value: string) => void,
}

export function DesktopSideBar({
  chosenTranslation,
  queriedBooks,
  queriedVerses,
  chosenBook,
  chosenChapter,
  queryInput,
  setQueryInput,
}: SideBarProps) {
  const [searchHidden, setSearchHidden] = useChromePart('search');

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
    }}>
      <NavigationBar />
      {!searchHidden && (
      <BibleSideBar
        chosenTranslation={chosenTranslation}
        queriedBooks={queriedBooks}
        queriedVerses={queriedVerses}
        chosenBook={chosenBook}
        chosenChapter={chosenChapter}
        queryInput={queryInput}
        setQueryInput={setQueryInput}
        onHide={() => setSearchHidden(true)}
      />
      )}
    </div>
  )
}
